import React, { useEffect, useRef, useState } from 'react';
import { DashboardLayout } from '../../Components/Layout/DashboardLayout';
import CustomInput from '../../Components/CustomInput';
import { useGet, usePost } from '../../Api';
import { apiErrorMessage, describeHttpFailure } from '../../Api/readJson';
import { SelectBox } from '../../Components/CustomSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import ImageUploader from '../../Components/ImageUpload';
import { useNavigate, useParams } from 'react-router';
import { useNotification } from '../../Components/GlobalNotification';
import { sanitizeInteger, sanitizeDecimal, sanitizeField, checkNumber, checkOptionalNumber } from './listingLimits';
import { dedupeTimings, canonicalTimingId } from './timingOptions';
import useListingLimits from './useListingLimits';

import { base_url } from '../../Api/apiConfig';

const defaultForm = {
  title: '',
  description: '',
  type_of_place: '',
  type_of_listing: '',
  bathrooms: '',
  size: '',
  unit_of_measure: '',
  location: {
    address: '',
    suite: '',
    country: '',
    country_id: '',
    state: '',
    state_id: '',
    city: '',
    city_id: '',
    zipcode: '',
  },
  bedrooms: [
    { bedroom_name: '', no_of_guests: '', no_of_beds: '', bed_type: '' },
  ],
  nightly: '',
  weekends: '',
  weekend_days: '',
  weekly_per_night: '',
  monthly_per_night: '',
  additional_guest: '',
  cleaning_fee_amount: '',
  cleaning_fee_unit: '',
  security_deposit: '',
  local_tax_percent: '',
  other_regional_taxes: '',
  value_added_tax: '',
  extra_service_fees: [
    { name: '', price: '', type: '' },
  ],
  cancellation_policy: '',
  minimum_days_of_a_booking: '',
  maximum_days_of_a_booking: '',
  check_in_after: '',
  check_out_by: '',
  smoking_allowed: null,
  pets_allowed: null,
  gatherings_allowed: null,
  children_allowed: null,
  additional_rules: '',
  available_dates: [],
  not_available_dates: [],
  amenity_id: [],
  facility_id: [],
  image_ids: [],
};

export const EditListingForm = () => {
  const { showNotification } = useNotification();
  const { L, error: limitsError } = useListingLimits();
  const { id } = useParams();

  const { ApiData: PlaceData, loading: PlaceLoading, error: PlaceError, get: GetPlace } = useGet(`/places`);
  const { ApiData: ListyingTypeData, loading: ListyingTypeLoading, error: ListyingTypeError, get: GetListyingType } = useGet(`/listing-types`);
  const { ApiData: SquareUnitData, loading: SquareUnitLoading, error: SquareUnitError, get: GetSquareUnit } = useGet(`/unit-of-measures`);
  const { ApiData: BedData, loading: BedLoading, error: BedError, get: GetBed } = useGet(`/bed-types`);
  const { ApiData: WeekData, loading: WeekLoading, error: WeekError, get: GetWeek } = useGet(`/weekend-days`);
  const { ApiData: FeeData, loading: FeeLoading, error: FeeError, get: GetFee } = useGet(`/fees-types`);
  const { ApiData: amenitiesData, loading: amenitiesLoading, error: amenitiesError, get: Getamenities } = useGet(`/amenities`);
  const { ApiData: facilitiesData, loading: facilitiesLoading, error: facilitiesError, get: Getfacilities } = useGet(`/facilities`);
  const { ApiData: timingData, loading: timingLoading, error: timingError, get: GetTiming } = useGet(`/listing-timings?per_page=100`);
  const { ApiData: ListingData, loading: ListingLoading, error: ListingError, get: GetListing } = useGet(`/listings/${id}`);
  const { ApiData: ListingImagesData, loading: ListingImagesLoading, error: ListingImagesError, get: GetListingImages } = useGet(`/listing/${id}/images`);
  const { ApiData: AddListingData, loading: AddListingLoading, error: AddListingError, post: GetAddListing } = usePost(`/listings/${id}`);
  const { ApiData: CountriesData, get: GetCountries } = useGet(`/countries`);
  const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [placeList, setPlaceList] = useState();
  const [listingList, setListingList] = useState();
  const [unitList, setUnitList] = useState();
  const [bedType, setBedType] = useState();
  const [weekype, setWeekype] = useState();
  const [feeype, setFeeype] = useState();
  const [amenities, setAmenities] = useState();
  const [facilites, setFacilites] = useState();
  const [timing, setTiming] = useState();
  const [form, setForm] = useState(defaultForm);
  const [listingImages, setListingImages] = useState([]);
  const listingImagesRef = useRef([]);
  listingImagesRef.current = listingImages;
  const [imageIds, setImageIds] = useState([]);
  const [isMediaUploading, setIsMediaUploading] = useState(false);
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (PlaceData) {
      setPlaceList(PlaceData?.data?.data)
    }
  }, [PlaceData]);


  useEffect(() => {
    if (ListyingTypeData) {
      setListingList(ListyingTypeData?.data?.data)
    }
  }, [ListyingTypeData]);


  useEffect(() => {
    if (SquareUnitData) {
      setUnitList(SquareUnitData?.data?.data)
    }
  }, [SquareUnitData]);


  useEffect(() => {
    if (BedData) {
      setBedType(BedData?.data?.data)
    }
  }, [BedData]);

  useEffect(() => {
    if (WeekData) {
      setWeekype(WeekData?.data?.data)
    }
  }, [WeekData]);


  useEffect(() => {
    if (FeeData) {
      setFeeype(FeeData?.data?.data)
    }
  }, [FeeData]);

  useEffect(() => {
    if (amenitiesData) {
      setAmenities(amenitiesData?.data?.data)
    }
  }, [amenitiesData]);

  useEffect(() => {
    if (facilitiesData) {
      setFacilites(facilitiesData?.data?.data)
    }
  }, [facilitiesData]);


  useEffect(() => {
    if (timingData) {
      setTiming(timingData?.data?.data)
    }
  }, [timingData]);

  useEffect(() => {
    const load = async () => {
      await GetPlace();
      await GetListyingType();
      await GetSquareUnit();
      await GetBed();
      await GetWeek();
      await GetFee();
      await Getamenities();
      await Getfacilities();
      await GetTiming();
      await GetCountries();
      await GetListing();
      await GetListingImages();
    };

    if (id) load();
  }, [id]);


  useEffect(() => {
    if (ListingData) {
      const loc = ListingData?.location ?? {};
      setForm({
        ...defaultForm,
        ...ListingData,
        location: {
          ...defaultForm.location,
          address: loc.address ?? '',
          suite: loc.suite ?? '',
          country: loc.country ?? '',
          country_id: loc.country_id ?? '',
          state: loc.state ?? '',
          state_id: loc.state_id ?? '',
          city: loc.city ?? '',
          city_id: loc.city_id ?? '',
          zipcode: loc.zipcode ?? '',
        },
        bedrooms: Array.isArray(ListingData?.bedrooms) && ListingData.bedrooms.length > 0
          ? ListingData.bedrooms
          : defaultForm.bedrooms,
        extra_service_fees: Array.isArray(ListingData?.extra_service_fees) && ListingData.extra_service_fees.length > 0
          ? ListingData.extra_service_fees
          : defaultForm.extra_service_fees,
        amenity_id: Array.isArray(ListingData?.amenity_id) ? ListingData.amenity_id : defaultForm.amenity_id,
        facility_id: Array.isArray(ListingData?.facility_id) ? ListingData.facility_id : defaultForm.facility_id,
      });
    }
  }, [ListingData]);

  useEffect(() => {
    const raw = CountriesData?.data?.data ?? CountriesData?.data ?? CountriesData ?? [];
    const list = Array.isArray(raw) ? raw.map((item) => ({
      id: item.id,
      name: item.name ?? item.country_name ?? item.title ?? ''
    })) : [];
    setCountriesList(list);
  }, [CountriesData]);

  useEffect(() => {
    if (!form?.location?.country_id) {
      setStatesList([]);
      return;
    }
    fetch(`${base_url}/state/by-country?country=${form.location.country_id}`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((res) => {
        const raw = res?.data?.data ?? res?.data ?? res ?? [];
        const list = Array.isArray(raw) ? raw.map((item) => ({
          id: item.id,
          name: item.name ?? item.state_name ?? item.title ?? ''
        })) : [];
        setStatesList(list);
      })
      .catch(() => setStatesList([]));
  }, [form?.location?.country_id]);

  useEffect(() => {
    if (!form?.location?.state_id) {
      setCitiesList([]);
      return;
    }
    fetch(`${base_url}/city/by-state?state=${form.location.state_id}`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((res) => {
        const raw = res?.data?.data ?? res?.data ?? res ?? [];
        const list = Array.isArray(raw) ? raw.map((item) => ({
          id: item.id,
          name: item.name ?? item.city_name ?? item.title ?? ''
        })) : [];
        setCitiesList(list);
      })
      .catch(() => setCitiesList([]));
  }, [form?.location?.state_id]);

  useEffect(() => {
    if (!form?.location?.country || !countriesList?.length || form?.location?.country_id) return;
    const name = String(form.location.country).trim().toLowerCase();
    const found = countriesList.find((c) => String(c.name || '').trim().toLowerCase() === name);
    if (found) {
      setForm((prev) => prev ? { ...prev, location: { ...prev.location, country_id: found.id } } : prev);
    }
  }, [form?.location?.country, form?.location?.country_id, countriesList]);

  useEffect(() => {
    if (!form?.location?.state || !statesList?.length || form?.location?.state_id) return;
    const name = String(form.location.state).trim().toLowerCase();
    const found = statesList.find((s) => String(s.name || '').trim().toLowerCase() === name);
    if (found) {
      setForm((prev) => prev ? { ...prev, location: { ...prev.location, state_id: found.id } } : prev);
    }
  }, [form?.location?.state, form?.location?.state_id, statesList]);

  useEffect(() => {
    if (!form?.location?.city || !citiesList?.length || form?.location?.city_id) return;
    const name = String(form.location.city).trim().toLowerCase();
    const found = citiesList.find((c) => String(c.name || '').trim().toLowerCase() === name);
    if (found) {
      setForm((prev) => prev ? { ...prev, location: { ...prev.location, city_id: found.id } } : prev);
    }
  }, [form?.location?.city, form?.location?.city_id, citiesList]);

  useEffect(() => {
    if (!ListingImagesData) return;

    // API response could be: { data: [] } or { data: { data: [] } } or [].
    const raw = Array.isArray(ListingImagesData?.images)
      ? ListingImagesData.images
      : Array.isArray(ListingImagesData?.data?.data)
        ? ListingImagesData.data.data
        : Array.isArray(ListingImagesData?.data)
          ? ListingImagesData.data
          : Array.isArray(ListingImagesData)
            ? ListingImagesData
            : [];

    const images = raw
      .filter(Boolean)
      .map((img) => ({
        ...img,
        source: 'existing',
      }));

    // Keep images uploaded in this session that are not attached to the listing yet
    const pendingNew = listingImagesRef.current.filter(
      (img) => img?.source === 'new' && !images.some((x) => x?.id === img?.id)
    );
    const merged = [...images, ...pendingNew];
    setListingImages(merged);

    const ids = merged
      .map((img) => img?.id)
      .filter((x) => x != null);

    setImageIds(ids);
    setForm((prev) => (prev ? { ...prev, image_ids: ids } : prev));
  }, [ListingImagesData]);


  useEffect(() => {
    console.log('listingDAta', form)
  }, [form])



  const BOOKING_DAYS_MAX = L?.BOOKING_DAYS_MAX;

  const sanitizeBookingDays = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const digitsOnly = String(value).replace(/\D/g, '');
    if (!digitsOnly) return '';
    const num = Math.min(parseInt(digitsOnly, 10), BOOKING_DAYS_MAX);
    return String(num);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue =
      name === 'minimum_days_of_a_booking' || name === 'maximum_days_of_a_booking'
        ? sanitizeBookingDays(value)
        : L && sanitizeField(name, value, L) !== undefined
          ? sanitizeField(name, value, L)
          : value;

    setForm((prevForm) => ({
      ...prevForm,
      [name]: newValue
    }));

    setErrors((prev) => {
      const updated = { ...prev };
      if (newValue !== '' && newValue !== null && newValue !== undefined) {
        delete updated[name];
      }
      return updated;
    });
  };

  const handleAddBedroom = () => {
    if ((form?.bedrooms?.length || 0) >= L.BEDROOMS_MAX) {
      showNotification({ type: 'error', title: 'Limit reached', message: `You can add at most ${L.BEDROOMS_MAX} bedrooms.` });
      return;
    }
    setForm(prev => ({
      ...prev,
      bedrooms: [...(prev.bedrooms || []), { bedroom_name: '', no_of_guests: '', no_of_beds: '', bed_type: '' }]
    }));
  };

  // Convert string numeric fields to numbers before submitting so Laravel validation passes.
  const sanitizeNumericValues = (data) => {
    const numericFields = [
      'nightly', 'weekends', 'weekly_per_night', 'monthly_per_night',
      'cleaning_fee_amount', 'security_deposit', 'local_tax_percent',
      'other_regional_taxes', 'value_added_tax',
      'bathrooms', 'size', 'unit_of_measure'
    ];
    const parsed = { ...data };

    numericFields.forEach((field) => {
      if (parsed[field] === '' || parsed[field] === null || parsed[field] === undefined) {
        parsed[field] = null;
      } else {
        const num = parseFloat(parsed[field]);
        parsed[field] = !isNaN(num) ? num : parsed[field];
      }
    });

    if (Array.isArray(parsed.bedrooms)) {
      parsed.bedrooms = parsed.bedrooms.map((room) => ({
        ...room,
        no_of_guests: room.no_of_guests === '' || room.no_of_guests == null
          ? null
          : parseInt(room.no_of_guests, 10) || room.no_of_guests,
        no_of_beds: room.no_of_beds === '' || room.no_of_beds == null
          ? null
          : parseInt(room.no_of_beds, 10) || room.no_of_beds,
        bed_type: room.bed_type === '' || room.bed_type == null ? null : room.bed_type,
      }));
    }

    if (Array.isArray(parsed.extra_service_fees)) {
      parsed.extra_service_fees = parsed.extra_service_fees.filter(isFeeRowFilled).map((fee) => ({
        ...fee,
        price: fee.price === '' || fee.price == null
          ? null
          : parseFloat(fee.price) || fee.price,
        type: fee.type === '' || fee.type == null ? null : fee.type,
      }));
    }

    return parsed;
  };

  const handleSaveAsDraft = () => {
    if (!form) return;
    const draftData = { ...sanitizeNumericValues(form), save_as_draft: 'true' };
    GetAddListing(draftData);
  };


  const handleAddService = () => {
    if ((form?.extra_service_fees?.length || 0) >= L.EXTRA_FEES_MAX) {
      showNotification({ type: 'error', title: 'Limit reached', message: `You can add at most ${L.EXTRA_FEES_MAX} extra service fees.` });
      return;
    }
    setForm(prev => ({
      ...prev,
      extra_service_fees: [...(prev.extra_service_fees || []), { name: '', price: '', type: '' }]
    }));
  };


  const handleRemoveBedroom = (index) => {
    const updatedBedrooms = form?.bedrooms.filter((_, i) => i !== index);
    setForm(prev => ({ ...prev, bedrooms: updatedBedrooms }));
  };

  const handleRemoveService = (index) => {
    const updatedBedrooms = form?.extra_service_fees.filter((_, i) => i !== index);
    setForm(prev => ({ ...prev, extra_service_fees: updatedBedrooms }));
  };


  const handleChangeBedroom = (e, index = null, key = null) => {
    const { name, value } = e.target;

    if (index !== null && key) {
      const updatedBedrooms = [...form?.bedrooms];
      updatedBedrooms[index][key] =
        key === 'no_of_guests' ? sanitizeInteger(value, L.GUESTS_PER_ROOM_MAX)
        : key === 'no_of_beds' ? sanitizeInteger(value, L.BEDS_PER_ROOM_MAX)
        : value;
      setForm(prev => ({ ...prev, bedrooms: updatedBedrooms }));

      const errorKey = `${key}_${index}`;
      setErrors((prev) => {
        const updated = { ...prev };
        if (value !== '' && value !== null && value !== undefined) {
          delete updated[errorKey];
        }
        return updated;
      });
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }

    console.log('testData', form)
  };


  const handleChangeService = (e, index = null, key = null) => {
    const { name, value } = e.target;

    if (index !== null && key) {
      const updatedBedrooms = [...form?.extra_service_fees];
      updatedBedrooms[index][key] = key === 'price' ? sanitizeDecimal(value, L.PRICE_MAX) : value;
      setForm(prev => ({ ...prev, extra_service_fees: updatedBedrooms }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }

    console.log('testData', form)
  };




  const handleLocationChange = (e) => {
    const { name, value } = e.target;
    let parsedValue = value;
    if (['country', 'state', 'city'].includes(name)) {
      parsedValue = value ? parseInt(value, 10) : '';
    }
    setForm((prevForm) => ({
      ...prevForm,
      location: {
        ...prevForm?.location,
        [name]: parsedValue
      }
    }));

    setErrors((prev) => {
      const updated = { ...prev };
      if (value !== '' && value !== null && value !== undefined) {
        delete updated[name];
      }
      return updated;
    });
  };

  const handleLocationSelect = (field, value, displayName) => {
    const id = value === '' ? '' : value;
    if (field === 'country_id') {
      setForm((prev) => prev ? {
        ...prev,
        location: {
          ...prev.location,
          country_id: id,
          country: displayName ?? '',
          state_id: '',
          state: '',
          city_id: '',
          city: '',
        },
      } : prev);
    } else if (field === 'state_id') {
      setForm((prev) => prev ? {
        ...prev,
        location: {
          ...prev.location,
          state_id: id,
          state: displayName ?? '',
          city_id: '',
          city: '',
        },
      } : prev);
    } else if (field === 'city_id') {
      setForm((prev) => prev ? {
        ...prev,
        location: {
          ...prev.location,
          city_id: id,
          city: displayName ?? '',
        },
      } : prev);
    }
  };

  const handleAmenityChange = (e) => {
    const value = parseInt(e.target.value); // Cast to number
    const { checked } = e.target;


    setForm((prevForm) => {
      const amenity_id = checked
        ? [...prevForm.amenity_id, value]
        : prevForm.amenity_id?.filter(item => item !== value);

      return {
        ...prevForm,
        amenity_id
      };
    });
  };


  const handleFacilitiesChange = (e) => {
    const value = parseInt(e.target.value); // Cast to number
    const { checked } = e.target;

    setForm((prevForm) => {
      const facility_id = checked
        ? [...prevForm.facility_id, value]
        : prevForm.facility_id.filter((item) => item !== value);

      return {
        ...prevForm,
        facility_id,
      };
    });
  };


  const isFeeRowFilled = (fee) =>
    ['name', 'price', 'type'].some((key) => fee?.[key] !== '' && fee?.[key] != null && String(fee[key]).trim() !== '');

  const validateStep = (step) => {
    if (!form) return true;
    const newErrors = {};
    let stepErrorKeys = [];

    if (step === 1) {
      stepErrorKeys = ['title', 'type_of_place', 'type_of_listing', 'unit_of_measure', 'bathrooms', 'size', 'description'];
      if (!form.title?.trim()) newErrors.title = 'Title is required';
      else if (form.title.trim().length < L.TITLE_MIN) newErrors.title = `Title must be at least ${L.TITLE_MIN} characters`;
      else if (form.title.length > L.TITLE_MAX) newErrors.title = `Title must not exceed ${L.TITLE_MAX} characters`;
      if (!form.type_of_place) newErrors.type_of_place = 'Type of place is required';
      if (!form.type_of_listing) newErrors.type_of_listing = 'Type of listing is required';
      if (!form.unit_of_measure) newErrors.unit_of_measure = 'Unit of measure is required';
      const bathroomsErr = checkNumber(form.bathrooms, { label: 'Bathrooms', min: 0, max: L.BATHROOMS_MAX, integer: true });
      if (bathroomsErr) newErrors.bathrooms = bathroomsErr;
      const sizeErr = checkNumber(form.size, { label: 'Size', min: 1, max: L.SIZE_MAX, integer: true });
      if (sizeErr) newErrors.size = sizeErr;
      if (!form.description?.trim()) newErrors.description = 'Description is required';
      else if (form.description.length > 2000) newErrors.description = 'Description must not exceed 2000 characters';
    }

    if (step === 2) {
      stepErrorKeys = ['address', 'country', 'state', 'city', 'zipcode'];
      if (!form.location?.address?.trim()) newErrors.address = 'Address is required';
      else if (form.location.address.length > 255) newErrors.address = 'Address must not exceed 255 characters';
      if (!form.location?.country) newErrors.country = 'Country is required';
      if (!form.location?.state) newErrors.state = 'State is required';
      if (!form.location?.city) newErrors.city = 'City is required';
      if (!form.location?.zipcode?.trim()) newErrors.zipcode = 'Postal code is required';
      else if (form.location.zipcode.length > 50) newErrors.zipcode = 'Postal code must not exceed 50 characters';
    }

    if (step === 3) {
      stepErrorKeys = [];
      form.bedrooms?.forEach((bed, index) => {
        stepErrorKeys.push(
          `bedroom_name_${index}`,
          `no_of_guests_${index}`,
          `no_of_beds_${index}`,
          `bed_type_${index}`
        );
        if (!bed.bedroom_name?.trim()) newErrors[`bedroom_name_${index}`] = 'Bedroom name is required';
        else if (bed.bedroom_name.length > 255) newErrors[`bedroom_name_${index}`] = 'Bedroom name must not exceed 255 characters';
        const guestsErr = checkNumber(bed.no_of_guests, { label: 'No. guests', min: 1, max: L.GUESTS_PER_ROOM_MAX, integer: true });
        if (guestsErr) newErrors[`no_of_guests_${index}`] = guestsErr;
        const bedsErr = checkNumber(bed.no_of_beds, { label: 'No. beds', min: 1, max: L.BEDS_PER_ROOM_MAX, integer: true });
        if (bedsErr) newErrors[`no_of_beds_${index}`] = bedsErr;
        if (!bed.bed_type) newErrors[`bed_type_${index}`] = 'Bed type is required';
      });
      if ((form.bedrooms?.length || 0) > L.BEDROOMS_MAX) {
        newErrors[`bedroom_name_${L.BEDROOMS_MAX}`] = `You can add at most ${L.BEDROOMS_MAX} bedrooms`;
      }
      const totalGuests = (form.bedrooms || []).reduce((sum, bed) => sum + (parseInt(bed.no_of_guests, 10) || 0), 0);
      if (totalGuests > L.TOTAL_GUESTS_MAX) {
        newErrors.no_of_guests_0 = `Total guests across all bedrooms must not exceed ${L.TOTAL_GUESTS_MAX} (currently ${totalGuests})`;
      }
    }

    if (step === 4) {
      stepErrorKeys = ['nightly', 'weekends', 'weekend_days', 'weekly_per_night', 'monthly_per_night', 'cleaning_fee_amount', 'cleaning_fee_unit', 'security_deposit'];
      const price = { max: L.PRICE_MAX };
      const pct = { max: L.PERCENT_MAX };
      const priceChecks = {
        nightly: checkNumber(form.nightly, { ...price, label: 'Nightly price', min: L.PRICE_MIN }),
        weekends: checkNumber(form.weekends, { ...price, label: 'Weekends price', min: L.PRICE_MIN }),
        weekly_per_night: checkNumber(form.weekly_per_night, { ...price, label: 'Weekly price', min: L.PRICE_MIN }),
        monthly_per_night: checkNumber(form.monthly_per_night, { ...price, label: 'Monthly price', min: L.PRICE_MIN }),
        cleaning_fee_amount: checkNumber(form.cleaning_fee_amount, { ...price, label: 'Cleaning fee' }),
        security_deposit: checkNumber(form.security_deposit, { ...price, label: 'Security deposit' }),
        local_tax_percent: checkOptionalNumber(form.local_tax_percent, { ...pct, label: 'Local tax' }),
        other_regional_taxes: checkOptionalNumber(form.other_regional_taxes, { ...pct, label: 'Other regional taxes' }),
        value_added_tax: checkOptionalNumber(form.value_added_tax, { ...pct, label: 'Value added tax' }),
      };
      Object.entries(priceChecks).forEach(([field, err]) => { if (err) newErrors[field] = err; });
      stepErrorKeys.push('local_tax_percent', 'other_regional_taxes', 'value_added_tax');
      if (!form.weekend_days) newErrors.weekend_days = 'Weekend days selection is required';
      if (!form.cleaning_fee_unit) newErrors.cleaning_fee_unit = 'Cleaning fee type is required';
      form.extra_service_fees?.forEach((fee, index) => {
        stepErrorKeys.push(`extra_service_fee_name_${index}`, `extra_service_fee_price_${index}`, `extra_service_fee_type_${index}`);
        // A completely empty row is ignored; a partly filled row must be complete
        if (isFeeRowFilled(fee)) {
          if (!String(fee.name ?? '').trim()) newErrors[`extra_service_fee_name_${index}`] = 'Fee name is required';
          if (fee.price === '' || fee.price == null) newErrors[`extra_service_fee_price_${index}`] = 'Fee price is required';
          else {
            const feeErr = checkNumber(fee.price, { label: 'Fee price', min: 0, max: L.PRICE_MAX });
            if (feeErr) newErrors[`extra_service_fee_price_${index}`] = feeErr;
          }
          if (!fee.type) newErrors[`extra_service_fee_type_${index}`] = 'Fee type is required';
        }
      });
      if ((form.extra_service_fees?.length || 0) > L.EXTRA_FEES_MAX) {
        newErrors.extra_service_fee_price_0 = `You can add at most ${L.EXTRA_FEES_MAX} extra service fees`;
      }
    }

    if (step === 7) {
      stepErrorKeys = ['cancellation_policy', 'minimum_days_of_a_booking', 'maximum_days_of_a_booking', 'check_in_after', 'check_out_by', 'smoking_allowed', 'pets_allowed', 'gatherings_allowed', 'children_allowed', 'additional_rules'];
      if (!form.cancellation_policy) newErrors.cancellation_policy = 'Cancellation policy is required';
      const minErr = checkNumber(form.minimum_days_of_a_booking, { label: 'Minimum days', min: 1, max: L.BOOKING_DAYS_MAX, integer: true });
      if (minErr) newErrors.minimum_days_of_a_booking = minErr;
      const maxErr = checkNumber(form.maximum_days_of_a_booking, { label: 'Maximum days', min: 1, max: L.BOOKING_DAYS_MAX, integer: true });
      if (maxErr) newErrors.maximum_days_of_a_booking = maxErr;
      else if (!minErr && Number(form.minimum_days_of_a_booking) > Number(form.maximum_days_of_a_booking)) {
        newErrors.maximum_days_of_a_booking = 'Maximum days must be greater than or equal to minimum days';
      }
      if (!form.check_in_after) newErrors.check_in_after = 'Check-in time is required';
      if (!form.check_out_by) newErrors.check_out_by = 'Check-out time is required';
      const isYesNo = (v) => v === true || v === false || v === 'true' || v === 'false';
      if (!isYesNo(form.smoking_allowed)) newErrors.smoking_allowed = 'Please select smoking option';
      if (!isYesNo(form.pets_allowed)) newErrors.pets_allowed = 'Please select pets option';
      if (!isYesNo(form.gatherings_allowed)) newErrors.gatherings_allowed = 'Please select gatherings option';
      if (!isYesNo(form.children_allowed)) newErrors.children_allowed = 'Please select children option';
      if (form.additional_rules?.trim() && form.additional_rules.length > 2000) {
        newErrors.additional_rules = 'Additional rules must not exceed 2000 characters';
      }
    }

    if (stepErrorKeys.length) {
      setErrors((prev) => {
        const updated = { ...prev };
        stepErrorKeys.forEach((key) => { delete updated[key]; });
        return { ...updated, ...newErrors };
      });
    } else {
      setErrors(prev => ({ ...prev, ...newErrors }));
    }

    if (Object.keys(newErrors).length) {
      showNotification({ type: 'error', title: 'Error', message: (() => {
          const problems = Object.values(newErrors);
          const shown = problems.slice(0, 3).join('. ');
          return `Please fix the following before continuing: ${shown}${problems.length > 3 ? ` (+${problems.length - 3} more)` : ''}.`;
        })() });
      return false;
    }

    return true;
  };

  const handleStepChange = (step) => {
    if (step > currentStep && !validateStep(currentStep)) {
      return;
    }
    setCurrentStep(step);
  };

  const handleImageIdsChange = (ids) => {
    const normalized = Array.isArray(ids) ? ids : [];
    setImageIds(normalized);
    setForm((prev) => (prev ? { ...prev, image_ids: normalized } : prev));
  };

  const handleRemoveListingImage = async (img) => {
    // Only delete images that already belong to the listing
    if (img?.source !== 'existing') return true;

    const token = localStorage.getItem('login');
    if (!token) {
      showNotification({ type: 'error', title: 'Error', message: 'You are not logged in. Please login again.' });
      return false;
    }

    try {
      const response = await fetch(`${base_url}/listing/${id}/images/${img?.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        showNotification({ type: 'error', title: 'Error', message: payload?.message || describeHttpFailure(response.status) });
        return false;
      }

      showNotification({ type: 'success', title: 'Success', message: payload?.message || 'Image deleted.' });
      // Refresh server truth (optional but keeps UI in sync)
      GetListingImages();
      return true;
    } catch (e) {
      showNotification({ type: 'error', title: 'Error', message: 'Network error while deleting image.' });
      return false;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const stepsToValidate = [1, 2, 3, 4, 7];
    const allValid = stepsToValidate.every(step => validateStep(step));
    if (!allValid) return;
    GetAddListing(sanitizeNumericValues(form));
    console.log(form);
  };



  useEffect(() => {
    if (AddListingData) {
      showNotification({
        type: 'success',
        title: 'Success',
        message: AddListingData?.message || AddListingData?.data?.message || 'Saved successfully!',
        onClose: () => navigate(AddListingData?.data?.is_draft ? '/draft-listings' : '/listing-management')
      });
      // Auto-redirect after a short delay so the user sees the success message
      setTimeout(() => {
        navigate(AddListingData?.data?.is_draft ? '/draft-listings' : '/listing-management');
      }, 2000);
    }
  }, [AddListingData]);

  useEffect(() => {
    if (AddListingError) {
      showNotification({ type: 'error', title: 'Error', message: apiErrorMessage(AddListingError, 'Something went wrong.') });
    }
  }, [AddListingError]);

  // NOTE: ImageUploader returns an array of image IDs via onChange

  // Limits come from the admin-managed Listing Rules; the form cannot validate without them.
  if (!L) {
    return (
      <DashboardLayout>
        <div className="p-4 text-center">
          {limitsError
            ? <p className="text-danger">Could not load the listing rules. Please refresh the page or try again later.</p>
            : <p>Loading listing rules...</p>}
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="container">
        <div className='mainHeading'>
          <h2 className="my-4">Edit Listing</h2>
        </div>
        <div className='row justiffy-content-center'>
          <div className='mb-3 col-md-10'>
            <form onSubmit={handleSubmit}>
              {/* Step 1: Basic Info */}
              {currentStep === 1 && (
                <div className="step">
                  <h4 className='subTitke'>Information</h4>

                  <div className='row'>
                    <div className='mb-3 col-md-12'>
                      <div className="form-group">
                        <CustomInput
                          label="Title"
                          type="text"
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="title"
                          name="title"
                          value={form?.title || ''}
                          onChange={handleChange}
                        />
                        {errors.title && <small className="text-danger">{errors.title}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <SelectBox
                          label="Type of Place"
                          required
                          placeholder="Select Type of Place"
                          name="type_of_place"
                          value={form?.type_of_place}
                          option={placeList}
                          selectClass="mainInput"
                          onChange={handleChange}
                        />
                        {errors.type_of_place && <small className="text-danger">{errors.type_of_place}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Type of Listing</label>
                        <div className="fieldData">
                          <select className='mainInput' name='type_of_listing' onChange={handleChange} value={form?.type_of_listing || ''}>
                            <option value='' className='text-capitalize'>
                              Select Type of Listing
                            </option>
                            {Array.isArray(listingList) && listingList?.map(item => (

                              <option key={item?.id} value={item?.id}>{item?.listing_name}</option>
                            ))
                            }
                          </select>
                          {errors.type_of_listing && <small className="text-danger">{errors.type_of_listing}</small>}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Unit of Measure</label>
                        <div className="fieldData">
                          <select className='mainInput' name='unit_of_measure' value={form?.unit_of_measure || ''} onChange={handleChange}>
                            <option value='' className='text-capitalize'>
                              Select Unit of Measure
                            </option>
                            {Array.isArray(unitList) && unitList?.map(item => (

                              <option key={item?.id} value={item?.id}>{item?.measure_name}</option>
                            ))
                            }
                          </select>
                          {errors.unit_of_measure && <small className="text-danger">{errors.unit_of_measure}</small>}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <div className="form-group">

                        <CustomInput
                          type="number"
                          label="Bathrooms"
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="bathrooms"
                          name="bathrooms"
                          value={form?.bathrooms ?? ''}
                          onChange={handleChange}
                        />
                        {errors.bathrooms && <small className="text-danger">{errors.bathrooms}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <div className="form-group">
                        <CustomInput
                          type="number"
                          label="Size of living area"
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="size"
                          name="size"
                          value={form?.size ?? ''}
                          onChange={handleChange}
                        />
                        {errors.size && <small className="text-danger">{errors.size}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-12'>
                      <div className="form-group">
                        <label htmlFor="description" className='mainLabel'>Description</label>
                        <textarea rows={8} className='mainInput listingDescription' name='description' maxLength={2000} value={form?.description || ''} onChange={handleChange}></textarea>
                        {errors.description && <small className="text-danger">{errors.description}</small>}
                      </div>
                    </div>
                  </div>
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-end gap-2'>
                      <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                        {AddListingLoading ? 'Saving...' : 'Save for Later'}
                      </button>
                      <button type="button" className="btn btn-primary" onClick={() => handleStepChange(2)}>
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 2: Location */}
              {currentStep === 2 && (
                <div className="step">
                  <h4 className='subTitke'>Location</h4>
                  <div className='row'>

                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="text"
                        label="Address"
                        maxLength={255}
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="address"
                        name="address"
                        value={form?.location?.address || ""}
                        onChange={handleLocationChange}
                      />
                      {errors.address && <small className="text-danger">{errors.address}</small>}
                    </div>

                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="text"
                        label="Apt, Suite"
                        maxLength={255}
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="suite"
                        name="suite"
                        value={form?.location?.suite || ""}
                        onChange={handleLocationChange}
                      />
                    </div>

                    <div className='mb-3 col-md-4'>
                      <SelectBox
                        label="Country"
                        required
                        labelClass='mainLabel'
                        placeholder="Select Country"
                        name="country_id"
                        value={form?.location?.country_id ?? ''}
                        option={countriesList}
                        selectClass="mainInput"
                        onChange={(e) => {
                          const value = e.target.value;
                          const option = countriesList.find((c) => String(c.id) === String(value));
                          handleLocationSelect('country_id', value, option?.name);
                        }}
                      />
                      {errors.country && <small className="text-danger">{errors.country}</small>}
                    </div>

                    <div className='mb-3 col-md-4'>
                      <SelectBox
                        label="State"
                        required
                        labelClass='mainLabel'
                        placeholder="Select State"
                        name="state_id"
                        value={form?.location?.state_id ?? ''}
                        option={statesList}
                        selectClass="mainInput"
                        onChange={(e) => {
                          const value = e.target.value;
                          const option = statesList.find((s) => String(s.id) === String(value));
                          handleLocationSelect('state_id', value, option?.name);
                        }}
                      />
                      {errors.state && <small className="text-danger">{errors.state}</small>}
                    </div>

                    <div className='mb-3 col-md-4'>
                      <SelectBox
                        label="City"
                        required
                        labelClass='mainLabel'
                        placeholder="Select City"
                        name="city_id"
                        value={form?.location?.city_id ?? ''}
                        option={citiesList}
                        selectClass="mainInput"
                        onChange={(e) => {
                          const value = e.target.value;
                          const option = citiesList.find((c) => String(c.id) === String(value));
                          handleLocationSelect('city_id', value, option?.name);
                        }}
                      />
                      {errors.city && <small className="text-danger">{errors.city}</small>}
                    </div>
                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="text"
                        label="ZIP/Postal code"
                        maxLength={50}
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="zipcode"
                        name="zipcode"
                        value={form?.location?.zipcode || ""}
                        onChange={handleLocationChange}
                      />
                      {errors.zipcode && <small className="text-danger">{errors.zipcode}</small>}
                    </div>

                  </div>

                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(1)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                          {AddListingLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(3)}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {/* Step 3: Bedrooms */}
              {currentStep === 3 && (
                <div className="step">
                  <h4 className='subTitke'>Bedrooms</h4>

                  <div className='d-flex justify-content-end mb-3'>
                    <button type='button' className='btn btn-success' onClick={handleAddBedroom}>
                      <FontAwesomeIcon icon={faPlus} /> Add Room
                    </button>
                  </div>

                  {(!form?.bedrooms || form.bedrooms.length === 0) && (
                    <p className="text-muted text-center py-3">No bedrooms added yet. Click "Add Room" to add one.</p>
                  )}

                  {form?.bedrooms?.map((item, index) => (
                    <div className='row border rounded p-2 mb-3' key={index}>
                      <div className='mb-2 col-md-12'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <strong>Bedroom {index + 1}</strong>
                          {form.bedrooms.length > 1 && (
                            <button type='button' className='btn btn-danger btn-sm' onClick={() => handleRemoveBedroom(index)}>
                              <FontAwesomeIcon icon={faTrash} /> Remove
                            </button>
                          )}
                        </div>
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="text"
                          label={`Bedroom Name ${index + 1}`}
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`bedroom_name_${index}`}
                          value={item?.bedroom_name || ''}
                          name="bedroom_name"
                          onChange={(e) => handleChangeBedroom(e, index, 'bedroom_name')}
                        />
                        {errors[`bedroom_name_${index}`] && <small className="text-danger">{errors[`bedroom_name_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="text"
                          label="No. Guests"
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`no_of_guest_${index}`}
                          value={item?.no_of_guests ?? ''}
                          name="no_of_guests"
                          onChange={(e) => handleChangeBedroom(e, index, 'no_of_guests')}
                        />
                        {errors[`no_of_guests_${index}`] && <small className="text-danger">{errors[`no_of_guests_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="text"
                          label="No. Beds"
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`no_of_bed_${index}`}
                          value={item?.no_of_beds ?? ''}
                          name="no_of_beds"
                          onChange={(e) => handleChangeBedroom(e, index, 'no_of_beds')}
                        />
                        {errors[`no_of_beds_${index}`] && <small className="text-danger">{errors[`no_of_beds_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <div className="inputWrapper">
                          <label className='mainLabel'>Bed Type</label>
                          <div className="fieldData">
                            <select
                              className='mainInput'
                              name='bed_type'
                              value={item?.bed_type || ''}
                              onChange={(e) => handleChangeBedroom(e, index, 'bed_type')}
                            >
                              <option value="">Select Bed Type</option>
                              {Array.isArray(bedType) && bedType
                                ?.filter((data) => !['twin', 'full'].includes((data?.bed_name || '').toLowerCase()))
                                ?.map((data, i) => (
                                <option key={i} value={data?.id}>{data?.bed_name}</option>
                              ))}
                            </select>
                            {errors[`bed_type_${index}`] && <small className="text-danger">{errors[`bed_type_${index}`]}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(2)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                          {AddListingLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(4)}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3: Pricing */}
              {currentStep === 4 && (
                <div className="step">
                  <h4 className="subTitke">Pricing</h4>

                  <div className="row">
                    {/* Nightly */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Nightly"
                        placeholder="$"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="nightly"
                        name="nightly"
                        value={form?.nightly ?? ""}
                        onChange={handleChange}
                      />
                      {errors.nightly && <small className="text-danger">{errors.nightly}</small>}
                    </div>

                    {/* Weekends */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="text"
                        label="Weekends"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="weekends"
                        name="weekends"
                        value={form?.weekends ?? ""}
                        onChange={handleChange}
                      />
                      {errors.weekends && <small className="text-danger">{errors.weekends}</small>}
                    </div>

                    {/* Weekend days selector */}
                    <div className="mb-3 col-md-4">
                      <label className="mainLabel">
                        Select the days to apply weekend pricing
                      </label>
                      <select
                        className="mainInput"
                        name="weekend_days"
                        value={form?.weekend_days ?? ""}
                        onChange={handleChange}
                      >
                        <option value="">Select the days</option>
                        {Array.isArray(weekype) &&
                          weekype.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.days_name}
                            </option>
                          ))}
                      </select>
                      {errors.weekend_days && <small className="text-danger">{errors.weekend_days}</small>}
                    </div>

                    {/* Long‑term pricing */}
                    <div className="mb-3 col-md-12">
                      <h5 className="subHeadTitle">Long‑term pricing</h5>
                    </div>

                    <div className="mb-3 col-md-6">
                      <CustomInput
                        type="number"
                        label="Weekly – 7+ nights"
                        placeholder="Price Per Night"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="weekly_per_night"
                        name="weekly_per_night"
                        value={form?.weekly_per_night ?? ""}
                        onChange={handleChange}
                      />
                      {errors.weekly_per_night && <small className="text-danger">{errors.weekly_per_night}</small>}
                    </div>

                    <div className="mb-3 col-md-6">
                      <CustomInput
                        type="number"
                        label="Monthly – 30+ nights"
                        placeholder="Price Per Night"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="monthly_per_night"
                        name="monthly_per_night"
                        value={form?.monthly_per_night ?? ""}
                        onChange={handleChange}
                      />
                      {errors.monthly_per_night && <small className="text-danger">{errors.monthly_per_night}</small>}
                    </div>

                    {/* Cleaning‑fee type (radio) */}
                    <div className="mb-3 col-md-12">
                      <h5 className="subHeadTitle">Additional cost</h5>
                    </div>

                    <div className="mb-3 col-md-2">
                      <input
                        type="radio"
                        name="cleaning_fee_unit"
                        id="daily"
                        value="daily"
                        checked={form?.cleaning_fee_unit === "daily"}
                        onChange={handleChange}
                      />
                      <label htmlFor="daily" className="mx-2 mt-4">
                        Daily
                      </label>
                    </div>

                    <div className="mb-3 col-md-2">
                      <input
                        type="radio"
                        name="cleaning_fee_unit"
                        id="perstay"
                        value="perstay"
                        checked={form?.cleaning_fee_unit === "perstay"}
                        onChange={handleChange}
                      />
                      <label htmlFor="perstay" className="mx-2 mt-4">
                        Per Stay
                      </label>
                    </div>

                    <div className="mb-3 col-md-8">
                      {errors.cleaning_fee_unit && <small className="text-danger">{errors.cleaning_fee_unit}</small>}
                    </div>

                    {/* Cleaning fee */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Cleaning fee"
                        placeholder="$"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="cleaning_fee_amount"
                        name="cleaning_fee_amount"
                        value={form?.cleaning_fee_amount ?? ""}
                        onChange={handleChange}
                      />
                      {errors.cleaning_fee_amount && <small className="text-danger">{errors.cleaning_fee_amount}</small>}
                    </div>

                    {/* Security deposit */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Security deposit"
                        placeholder="$"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="security_deposit"
                        name="security_deposit"
                        value={form?.security_deposit ?? ""}
                        onChange={handleChange}
                      />
                      {errors.security_deposit && <small className="text-danger">{errors.security_deposit}</small>}
                    </div>

                    {/* Taxes */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Local Tax %"
                        placeholder="%"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="local_tax_percent"
                        name="local_tax_percent"
                        value={form?.local_tax_percent ?? ""}
                        onChange={handleChange}
                      />
                      {errors.local_tax_percent && <small className="text-danger">{errors.local_tax_percent}</small>}
                    </div>

                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Other Regional Taxes"
                        placeholder="%"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="other_regional_taxes"
                        name="other_regional_taxes"
                        value={form?.other_regional_taxes ?? ""}
                        onChange={handleChange}
                      />
                      {errors.other_regional_taxes && <small className="text-danger">{errors.other_regional_taxes}</small>}
                    </div>

                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="number"
                        label="Value Added Tax or equivalent (If applicable)"
                        placeholder="%"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="value_added_tax"
                        name="value_added_tax"
                        value={form?.value_added_tax ?? ""}
                        onChange={handleChange}
                      />
                      {errors.value_added_tax && <small className="text-danger">{errors.value_added_tax}</small>}
                    </div>

                    {/* Warning */}
                    <div className="mb-3 col-md-12">
                      <p className="text-danger">
                        * It is the host’s responsibility to know the tax regulations pertaining
                        to the region of the rental property, to calculate and list taxes, and
                        to remit those taxes to the appropriate officials.
                      </p>
                    </div>

                    {/* Extra service fees */}
                    <div className="mb-3 col-md-12">
                      <h5 className="subHeadTitle">Extra Service Fees</h5>

                      <div className="d-flex justify-content-end mb-2">
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={handleAddService}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add More
                        </button>
                      </div>

                      {(!form?.extra_service_fees || form.extra_service_fees.length === 0) && (
                        <p className="text-muted text-center py-3">No extra service fees added yet. Click "Add More" to add one.</p>
                      )}

                      {form?.extra_service_fees?.map((item, index) => (
                        <div className="row border rounded p-2 mb-3" key={index}>
                          <div className="mb-2 col-md-12">
                            <div className="d-flex justify-content-between align-items-center">
                              <strong>Fee {index + 1}</strong>
                              {form.extra_service_fees.length > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleRemoveService(index)}
                                >
                                  <FontAwesomeIcon icon={faTrash} /> Remove
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="mb-3 col-md-4">
                            <CustomInput
                              type="text"
                              label="Name"
                              maxLength={255}
                              labelClass="mainLabel"
                              inputClass="mainInput"
                              id={`name_${index}`}
                              name="name"
                              value={item?.name ?? ""}
                              onChange={(e) => handleChangeService(e, index, "name")}
                            />
                            {errors[`extra_service_fee_name_${index}`] && <small className="text-danger">{errors[`extra_service_fee_name_${index}`]}</small>}
                          </div>

                          <div className="mb-3 col-md-4">
                            <CustomInput
                              type="text"
                              label="Price"
                              labelClass="mainLabel"
                              inputClass="mainInput"
                              id={`price_${index}`}
                              name="price"
                              value={item?.price ?? ""}
                              onChange={(e) => handleChangeService(e, index, "price")}
                            />
                            {errors[`extra_service_fee_price_${index}`] && <small className="text-danger">{errors[`extra_service_fee_price_${index}`]}</small>}
                          </div>

                          <div className="mb-3 col-md-4">
                            <label className="mainLabel">Type</label>
                            <select
                              className="mainInput"
                              name="type"
                              value={item?.type ?? ""}
                              onChange={(e) => handleChangeService(e, index, "type")}
                            >
                              <option value="">Select Fee Type</option>
                              {Array.isArray(feeype) &&
                                feeype?.map((data) => (
                                  <option key={data.id} value={data.id}>
                                    {data.fees_name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Nav buttons */}
                  <div className="mb-3 col-md-12">
                    <div className="stepButon d-flex justify-content-between">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => handleStepChange(3)}
                      >
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                          {AddListingLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => handleStepChange(5)}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              )}



              {currentStep === 5 && (
                <div className="step">
                  <h4 className='subTitke'>Media</h4>
                  <ImageUploader
                    multiple={true}
                    initialImages={listingImages}
                    onChange={handleImageIdsChange}
                    onImagesChange={setListingImages}
                    onRemove={handleRemoveListingImage}
                    onUploadingChange={setIsMediaUploading}
                    listingId={id}
                    maxImages={L.IMAGES_MAX}
                    maxFileMb={L.IMAGE_MAX_MB}
                  />
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(4)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                          {AddListingLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => handleStepChange(6)}
                          disabled={isMediaUploading || (imageIds?.length ?? 0) === 0}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {/* amenities and facilities  */}


              {currentStep === 6 && (
                <div className="step">
                  <h4 className='subTitke'>Features</h4>
                  <div className='row'>
                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Amenities</h5>
                      </div>
                    </div>
                    {
                      amenities && amenities.map((item, index) => (
                        <div className='mb-3 col-md-4 mb-4' key={index}>
                          <input
                            type="checkbox"
                            name="amenity_id"
                            value={item?.id}
                            id={`amen-${index}`}
                            checked={(form?.amenity_id || []).includes(item?.id)}
                            onChange={(e) => handleAmenityChange(e)}
                          />
                          <label htmlFor={`amen-${index}`} className='mx-2'>{item?.amenity_name}</label>
                        </div>
                      ))
                    }


                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Facilities</h5>
                      </div>
                    </div>
                    {
                      facilites && facilites?.map((item, index) => (
                        <div className='mb-3 col-md-4 mb-4' key={index}>
                          <input
                            type="checkbox"
                            name="facility_id"
                            value={item?.id}
                            id={`facility-${index}`}
                            checked={form?.facility_id?.includes(item?.id)}
                            onChange={(e) => handleFacilitiesChange(e)}
                          />
                          <label htmlFor={`facility-${index}`} className='mx-2'>{item?.facility_name}</label>
                        </div>
                      ))
                    }
                    <div className='mb-3 col-md-12'>
                      <div className='stepButon d-flex justify-content-between'>
                        <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(5)}>
                          Back
                        </button>
                        <div className="d-flex gap-2">
                          <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                            {AddListingLoading ? 'Saving...' : 'Save for Later'}
                          </button>
                          <button type="button" className="btn btn-primary" onClick={() => handleStepChange(7)}>
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 7 && (
                <div className="step">
                  <h4 className="subTitke">Terms & rules</h4>
                  <div className="row">
                    {/* Cancellation Policy */}
                    <div className="mb-3 col-md-4">
                      <label className="mainLabel">Cancellation Policy</label>
                      <select
                        className="mainInput"
                        name="cancellation_policy"
                        value={form?.cancellation_policy ?? ""}
                        onChange={handleChange}
                      >
                        <option value="">Select Policy</option>
                        <option value="No Refund">No Refund</option>
                        <option value="Limited">Limited</option>
                        <option value="Relaxed">Relaxed</option>
                      </select>
                      {errors.cancellation_policy && <small className="text-danger">{errors.cancellation_policy}</small>}
                    </div>

                    {/* Min & Max Booking Days */}
                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="text"
                        inputMode="numeric"
                        maxLength={3}
                        label="Minimum days of a booking"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="minimum_days_of_a_booking"
                        name="minimum_days_of_a_booking"
                        value={form?.minimum_days_of_a_booking ?? ""}
                        onChange={handleChange}
                      />
                      {errors.minimum_days_of_a_booking && <small className="text-danger">{errors.minimum_days_of_a_booking}</small>}
                    </div>

                    <div className="mb-3 col-md-4">
                      <CustomInput
                        type="text"
                        inputMode="numeric"
                        maxLength={3}
                        label="Maximum days of a booking*"
                        labelClass="mainLabel"
                        inputClass="mainInput"
                        id="maximum_days_of_a_booking"
                        name="maximum_days_of_a_booking"
                        value={form?.maximum_days_of_a_booking ?? ""}
                        onChange={handleChange}
                      />
                      {errors.maximum_days_of_a_booking && <small className="text-danger">{errors.maximum_days_of_a_booking}</small>}
                    </div>

                    {/* Check-in & Check-out */}
                    <div className="mb-3 col-md-6">
                      <label className="mainLabel">Check-in After</label>
                      <select
                        className="mainInput"
                        name="check_in_after"
                        value={canonicalTimingId(timing, form?.check_in_after)}
                        onChange={handleChange}
                      >
                        <option value="">Select Check-in</option>
                        {Array.isArray(timing) &&
                          dedupeTimings(timing).map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.time}
                            </option>
                          ))}
                      </select>
                      {errors.check_in_after && <small className="text-danger">{errors.check_in_after}</small>}
                    </div>

                    <div className="mb-3 col-md-6">
                      <label className="mainLabel">Check-out By</label>
                      <select
                        className="mainInput"
                        name="check_out_by"
                        value={canonicalTimingId(timing, form?.check_out_by)}
                        onChange={handleChange}
                      >
                        <option value="">Select Check-out</option>
                        {Array.isArray(timing) &&
                          dedupeTimings(timing).map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.time}
                            </option>
                          ))}
                      </select>
                      {errors.check_out_by && <small className="text-danger">{errors.check_out_by}</small>}
                    </div>

                    {/* Rules - Radio Buttons */}
                    <div className="mb-3 col-md-3">
                      <h6 className="mainLabel">Smoking allowed?</h6>
                      <div className="d-inline mx-2">
                        <label htmlFor="smoking_yes" className="px-2 mainLabel">Yes</label>
                        <input
                          type="radio"
                          name="smoking_allowed"
                          id="smoking_yes"
                          value="true"
                          checked={form?.smoking_allowed === true || form?.smoking_allowed === "true"}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="d-inline mx-2">
                        <label htmlFor="smoking_no" className="px-2 mainLabel">No</label>
                        <input
                          type="radio"
                          name="smoking_allowed"
                          id="smoking_no"
                          value="false"
                          checked={form?.smoking_allowed === false || form?.smoking_allowed === "false"}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.smoking_allowed && <small className="text-danger d-block mt-1">{errors.smoking_allowed}</small>}
                    </div>

                    <div className="mb-3 col-md-3">
                      <h6 className="mainLabel">Pets allowed?</h6>
                      <div className="d-inline mx-2">
                        <label htmlFor="pets_yes" className="px-2 mainLabel">Yes</label>
                        <input
                          type="radio"
                          name="pets_allowed"
                          id="pets_yes"
                          value="true"
                          checked={form?.pets_allowed === true || form?.pets_allowed === "true"}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="d-inline mx-2">
                        <label htmlFor="pets_no" className="px-2 mainLabel">No</label>
                        <input
                          type="radio"
                          name="pets_allowed"
                          id="pets_no"
                          value="false"
                          checked={form?.pets_allowed === false || form?.pets_allowed === "false"}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.pets_allowed && <small className="text-danger d-block mt-1">{errors.pets_allowed}</small>}
                    </div>

                    <div className="mb-3 col-md-3">
                      <h6 className="mainLabel">Gatherings allowed?</h6>
                      <div className="d-inline mx-2">
                        <label htmlFor="gath_yes" className="px-2 mainLabel">Yes</label>
                        <input
                          type="radio"
                          name="gatherings_allowed"
                          id="gath_yes"
                          value="true"
                          checked={form?.gatherings_allowed === true || form?.gatherings_allowed === "true"}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="d-inline mx-2">
                        <label htmlFor="gath_no" className="px-2 mainLabel">No</label>
                        <input
                          type="radio"
                          name="gatherings_allowed"
                          id="gath_no"
                          value="false"
                          checked={form?.gatherings_allowed === false || form?.gatherings_allowed === "false"}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.gatherings_allowed && <small className="text-danger d-block mt-1">{errors.gatherings_allowed}</small>}
                    </div>

                    <div className="mb-3 col-md-3">
                      <h6 className="mainLabel">Children allowed?</h6>
                      <div className="d-inline mx-2">
                        <label htmlFor="child_yes" className="px-2 mainLabel">Yes</label>
                        <input
                          type="radio"
                          name="children_allowed"
                          id="child_yes"
                          value="true"
                          checked={form?.children_allowed === true || form?.children_allowed === "true"}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="d-inline mx-2">
                        <label htmlFor="child_no" className="px-2 mainLabel">No</label>
                        <input
                          type="radio"
                          name="children_allowed"
                          id="child_no"
                          value="false"
                          checked={form?.children_allowed === false || form?.children_allowed === "false"}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.children_allowed && <small className="text-danger d-block mt-1">{errors.children_allowed}</small>}
                    </div>

                    {/* Additional Rules */}
                    <div className="mb-3 col-md-12">
                      <label htmlFor="additional_rules" className="mainLabel">
                        Additional rules information (Optional)
                      </label>
                      <textarea
                        className="mainInput"
                        name="additional_rules"
                        maxLength={2000}
                        value={form?.additional_rules ?? ""}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  {/* Navigation Buttons */}
                  <div className="mb-3 col-md-12">
                    <div className="stepButon d-flex justify-content-between">
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(6)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={AddListingLoading}>
                          {AddListingLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button className="btn btn-primary" type="submit" disabled={AddListingLoading}>
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};


